<template>
  <BaseButton primary @click="showReviewModal"> Review </BaseButton>
</template>

<script>
export default {
  inject: ['submitReview'],
  props: {
    approvalRequest: {
      type: Object,
      required: true,
    },
  },
  methods: {
    showReviewModal() {
      this.$modal.show({
        component: () => import('./ReviewModal.vue'),
        props: {
          action: this.submit,
        },
        on: {},
        hideEvent: 'hide',
      });
    },
    async submit(formData) {
      try {
        await this.submitReview({
          approval_request_id: this.approvalRequest.id,
          ...formData,
        });

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
